module.exports = __webpack_public_path__ + "superWomen.svg?3c0daca81117b6abff49f33c2e4e7f47";